import {makeid} from '../../helpers/CoreHelpers'
import jwtDecode from "jwt-decode";
import {isLocalHost} from "../../helpers/CoreHelpers";
import CoreConfig from "../../config/index"

export default {
    'name': process.env.APP_NAME,
    'api': {
        'endpoint': process.env.API_ENDPOINT,
        'cdn': process.env.CDN_ENDPOINT,
        getCdnEndPoint(){
            if (this.cdn){
                return this.cdn
            } else {
                return this.endpoint;
            }
        }
    },
    'language': process.env.LANGUAGE,
    'prefix': 'csod-awave--',
    'adminURL': document.getElementById('application').getAttribute('data-admin-url'),
    'frontURL': document.getElementById('application').getAttribute('data-front-url'),
    'client': document.getElementById('application').getAttribute('data-client'),
    'renderer': document.getElementById('application').getAttribute('data-renderer'),
    'initialRoute':document.getElementById('application').getAttribute('data-initial-route'),
    welcomeMessage() {
        if (this.getUser() != null) {
            return 'Welcome ' + this.getUser().userName;
        } else {
            return false;
        }
    },
    destroy:CoreConfig.destroy,
    set:CoreConfig.set,
    get:CoreConfig.get,
    clearStorage:CoreConfig.clearStorage,
    setToken:CoreConfig.setToken,
    getToken:CoreConfig.getToken,
    setUser:CoreConfig.setUser,
    getUser:CoreConfig.getUser,
    getApiConfig:CoreConfig.getApiConfig,
    getId:CoreConfig.getId,
    getStoragePrefixes:CoreConfig.getStoragePrefixes,
    generateId:CoreConfig.generateId,
    getSsoLink:CoreConfig.getSsoLink,
    getSsoId:CoreConfig.getSsoId,
    setSsoId:CoreConfig.setSsoId
};


// WEBPACK FOOTER //
// ./src/core/admin/config/index.js